// extracted by mini-css-extract-plugin
module.exports = {"alert":"ApproveWithSignatoryModal_alert__NJivx","label":"ApproveWithSignatoryModal_label__1ltEM"};